import { render } from "./ListProdutosFarmacias.vue?vue&type=template&id=46749734&scoped=true"
import script from "./ListProdutosFarmacias.vue?vue&type=script&lang=js"
export * from "./ListProdutosFarmacias.vue?vue&type=script&lang=js"

import "./ListProdutosFarmacias.vue?vue&type=style&index=0&id=46749734&scoped=true&lang=css"

import exportComponent from "/Users/robo1/Documents/Admin/campanha-pedido/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-46749734"]])

export default __exports__